import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Divider,
    Text,
} from '@chakra-ui/react';
import './styles.css'
import ForecastAlert from './ForecastAlert';
import { getRelativeTime, toTitleCase } from '../../utils/helpers';

const ForecastModal = (props) => {
    const { selectedForecastZone, isOpen, onClose } = props;

    if (!selectedForecastZone) {
        return null;
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent
                style={{
                    marginLeft: 15,
                    marginRight: 15,
                }}
            >
                <ModalHeader mr={8} pb={0}>
                    <Text size='md'>
                        {selectedForecastZone.NAME}
                    </Text>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontSize='sm' color='gray.500' mb={4}>
                        Last Updated
                        {' '}
                        {getRelativeTime(selectedForecastZone?.forecast.issuanceTime)}
                    </Text>
                    <Divider orientation='horizontal' style={{ marginBottom: 20 }} />
                    {selectedForecastZone?.forecast
                        && selectedForecastZone.forecast.advisories.length > 0
                        && selectedForecastZone.forecast.advisories.map((alert, index) => (
                            <ForecastAlert alert={alert} key={index} />
                        ))
                    }
                    {selectedForecastZone?.forecast?.subForecasts 
                        && selectedForecastZone?.forecast.subForecasts.map((subForecast, index) => (
                            <div style={{ marginBottom: 20 }} key={index}>
                                <strong>{toTitleCase(subForecast.timeframe)}</strong>
                                <p style={{ color: '#4A5568' }}>{subForecast.forecastText}</p>
                            </div>
                        )
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ForecastModal;
